import {
  DataRetentionMode,
  DEFAULT_DATA_RETENTION_ENABLED,
  DEFAULT_DATA_RETENTION_MODE,
} from '@conversed/shared/src/services/llm/psn.type';
import { z } from 'zod';

const CountryCodeSchema = z.object({
  code: z.string(),
  phoneCode: z.string(),
  local: z.boolean(),
});
export const ValidationConfigSchema = z.object({
  phone: z.object({
    countryCodes: z.array(CountryCodeSchema),
    allowAllPhoneNumbers: z.boolean(),
  }),
});

export const BotLanguagesUpdateSchema = z.object({
  language: z.string(),
  languages: z.string().array(),
});

export const BotLanguagesSchema = z.object({
  language: z.string().optional(),
  languages: z.string().array(),
});

export const DebugConfigSchema = z.object({
  keywords: z.object({
    restartFlow: z.string().optional(),
    getBackToBot: z.string().optional(),
    showUserData: z.string().optional(),
    sendSpecificBlock: z.string().optional(),
    changeLanguage: z.record(z.string(), z.string()).optional(),
  }),
});
export const UserDataMappingSchema = z.object({
  phone: z.string().optional(),
  email: z.string().optional(),
  address: z.string().optional(),
  name: z.string().optional(),
});
export const TimezoneConfigSchema = z.object({ timezone: z.string() });
export const StreamingResponseConfigSchema = z.object({
  useStreamingResponse: z.boolean(),
});
export const RestartPolicyWhitelistConfigSchema = z.object({
  restartPolicyWhitelist: z.string().array(),
});
export const UserProfileFieldsConfigSchema = z.object({
  userProfileFields: z.string().array(),
});
export const ChatPluginConfigSchema = z.object({
  chatPlugin: z.object({
    isEnabled: z.boolean().optional(),
    greeting: z.string().optional(),
    buttonText: z.string().optional(),
  }),
});

export const DataRetentionConfigSchema = z.object({
  mode: z.enum(DataRetentionMode).default(DEFAULT_DATA_RETENTION_MODE),
  enabled: z.boolean().default(DEFAULT_DATA_RETENTION_ENABLED),
  pseudonymizationEnabled: z.boolean(),
});

export const DataRetentionEnabledSchema = z.object({
  enabled: z.boolean(),
});

export const PseudonymizationEnabledSchema = z.object({
  enabled: z.boolean(),
});

export const DataRetentionModeSchema = z.object({
  mode: z.enum(DataRetentionMode),
});
